export const Layout = {
   primary: '#ed008a',
   secondary: '#cb1580',
   light: 'rgba(246,234,239,1)',
   textColor: 'rgba(0,0,0,0.8)',
   fontA: 'GSB',
};

export const myContainerStyle = {
   root: {
      width: '100%',
      padding: '2%',
   },
   container: {
      maxHeight: '50%',
   },
};
